export const setPremiumWith3AutoApplyCreditsFlag = () => {
  const timestamp = Date.now().toString()
  localStorage.setItem('provisioning-premium-with-3-auto-apply-credits', timestamp)
  document.cookie = 'provisioning-premium-with-3-auto-apply-credits=' + timestamp
}
